/*
 * @Description: 实时报到人数折线统计图
 * @Version: 1.0
 * @Author: 琴时
 * @Date: 2021-09-06 15:39:51
 * @LastEditors: 琴时
 * @LastEditTime: 2021-09-09 11:51:53
 */
import React from 'react'
import PropTypes from 'prop-types'
import ReactEchartsCore from 'echarts-for-react/lib/core'
import echarts from 'echarts/lib/echarts'
import 'echarts/lib/component/title'
import 'echarts/lib/component/tooltip'

import 'echarts/lib/chart/line'
import 'echarts/lib/chart/lines'

import styles from './styles.css'
import NHFetch from '../../utils/NHFetch.js'

const yxxtBasicUrl = 'api/zhxg-yxxt' //迎新管理服务后台接口基础路径
const errMaxCount = 3 // 请求异常最大次数
const speed = 10 * 1000 //轮询时间间隔

class _CenterTop1 extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      errCount: 0, //连续请求错误次数
      lineData: [], //实时报到人数统计数据
    }

    this.polling //轮询定时器
  }

  componentDidMount() {
    this.getData()
  }

  componentWillUnmount() {
    //组件卸载时清除轮询定时器
    if (this.polling) {
      clearTimeout(this.polling)
    }
  }

  /**
   * * 获取实时报到人数统计数据
   * @memberof _CenterTop1
   */
  getData = () => {
    NHFetch(yxxtBasicUrl + '/sstj/getRealTimeStatisticsForReportedByLcid', 'GET',{pkid: this.props.pkid})
      .then(res => {
        if (res && res.data) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: 0, lineData: res.data })
        }
      })
      .catch(err => {
        let errCount = this.state.errCount
        //如果请求异常次数未超过最大次数限制，则继续尝试
        if (errCount < errMaxCount) {
          this.polling = setTimeout(() => {
            this.getData()
          }, speed)
          this.setState({ errCount: errCount + 1 })
        } else {
          //异常超过3次后终止轮询
          if (this.polling) {
            clearTimeout(this.polling)
          }
        }
      })
  }

  /**
   * * 构造实时报到人数折线图
   * @memberof Home
   */
  getLineOption = () => {
    const { rem, lineData = [] } = this.state
    const xAxisData = [
      '08时',
      '09时',
      '10时',
      '11时',
      '12时',
      '13时',
      '14时',
      '15时',
      '16时',
      '17时',
      '18时',
    ]
    const linesDataObj = {}
    lineData.forEach(element => {
      let { bdsj, bdrs } = element
      bdsj = bdsj && bdsj.split(':')[0] + '时'
      linesDataObj[bdsj] = bdrs
    })
    const yAxisData = xAxisData.map(item => {
      if (item in linesDataObj) {
        return linesDataObj[item]
      } else {
        return 0
      }
    })
    const option = {
      // 标题
      title: {
        text: '实时报到人数',
        textStyle: {
          color: '#fff',
          fontSize: 0.14 * rem,
        },
        left: '10%',
      },
      // 悬浮提示
      tooltip: {
        trigger: 'axis',
        formatter: function (params) {
          params = params[0]
          return `${params.name}:${params.value}人`
        },
        //坐标轴指示器配置项
        axisPointer: {
          animation: false,
        },
      },
      // 布局
      grid: {
        top: 5,
        bottom: '30%',
      },
      // X轴
      xAxis: {
        type: 'category',
        axisLabel: {
          color: '#fff',
          fontSize: 0.12 * rem,
        },
        splitLine: {
          show: false,
        },
        axisLine: {
          lineStyle: {
            color: '#fff',
            width: 1,
          },
        },
        data: xAxisData,
      },
      /* Y轴 */
      yAxis: {
        type: 'value',
        axisLabel: {
          color: '#fff',
          fontSize: 0.12 * rem,
        },
        axisLine: {
          lineStyle: {
            color: '#fff',
            width: 1,
          },
        },
        splitLine: {
          show: false,
        },
        interval: 250, //y轴间隔刻度
      },
      series: [
        {
          data: yAxisData,
          type: 'line',
          smooth: true,
          itemStyle: {
            normal: {
              color: '#ffff00',
            },
          },
          areaStyle: {
            normal: { color: '#828e30' }, //改变区域颜色
          },
        },
      ],
    }
    return option
  }

  render() {
    return (
      <div className={styles.box_2_top_com}>
        {/* <div className={styles.lines}> */}
          <ReactEchartsCore
            style={{ width: '100%', height: '100%' }}
            echarts={echarts}
            option={this.getLineOption()}
            notMerge={true}
            lazyUpdate={true}
          />
        </div>
      // </div>
    )
  }
}

_CenterTop1.defaultProps = {}

_CenterTop1.propTypes = {
  rem: PropTypes.number,
}

export default _CenterTop1



// WEBPACK FOOTER //
// ./containers/Show-new/_CenterTop1.js